import { ORDER_DETAIL_ACTION, COMMON_CONTENT_ACTION, ORDER_DETAIL_ACTION_LOADER } from "../type"
 
const initialState ={
    loader : false,
    data :{},
    common_data :{}
}
 
const OrderDetailReducer  = (state = initialState, action) => {
    switch (action.type){
        case ORDER_DETAIL_ACTION_LOADER:{
            return {...state,loader : action.loader};
        }
        case ORDER_DETAIL_ACTION :{
            return {...state, data: action.data};
        }
        case COMMON_CONTENT_ACTION :{
             return {...state, common_data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default OrderDetailReducer;